//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { combineReducers } from "redux";

//  -- Reducers -----------------------
import { userBooksList } from "store/userBooks/reducers";
import {
    booksAllList,
    bookOrder,
    booksActiveInActive,
    userAllowedBooks,
    booksCoverList,
} from "store/books/reducers";
import { activities, activity, ownGraphicOrganizers, shareList } from "store/activities/reducers";
import { classes, currentClass, allClasses, currentAllTeacherClass } from "store/classes/reducers";
import { classActivities } from "store/classActivities/reducers";
import { classQuizzes } from "store/classQuizzes/reducers";
import { interaction, interactions } from "store/interactions/reducers";
import { bookNotes, classNotes, notes } from "store/notes/reducers";
import {
    currentOrg,
    districts,
    organizations,
    schools,
    orgTeacherData,
    allSchools,
    distDashboardInfo,
    distExamGraphData,
    distBookUsesData,
    distContentExamData,
    vocab_permission_for_user,
    class_toggle_permission,
    adminHomeInfo
} from "store/organizations/reducers";
import { matchMakingView } from "store/main_book_popup/reducers";
import { submissions } from "store/submissions/reducers";
import { quizzes, quiz } from "store/quizzes/reducers";
import {
    classUsers,
    userClasses,
    usersByClass,
} from "store/userClasses/reducers";
import {
    currentUser,
    users,
    allUser,
    allUserCount,
    distTeacher,
    distStudents,
    profile_config,
    all_district_teacher,
    profile_picture_picker,
    class_ai_config_enabled,
} from "store/users/reducers";
import { tipsBook } from "store/tips/reducers";
import { userPreference } from "store/userPreference/reducers";
import { selectedUser } from "store/selectedUser/reducers";
import {
    schoologyGradeCategory,
    schoologyAssignment,
    schoologyAllClassGradeCategory,
} from "store/schoologyauth/reducers";
import { feedback, feedbackForm } from "store/feedback/reducers";
import { logs } from "store/logs/reducers";
import { bookUnitList, googleCourseMapByDistrict } from "store/booksUnits/reducers";
import { alertView } from "store/alert/reducers";
import { resources, videos } from "store/resources/reducers";
import { tenant } from "store/classlink/reducers";
import storage from "redux-persist/lib/storage/session";
import { cleverCourses, cleverUserInfo } from "store/clever/reducers";
import { bookmarks } from "store/bookmark/reducers";
import { servertime } from "store/servertime/reducers";
import {
    chatUser,
    chatMessages,
    socketConnection,
    userChatConfig,
    scheduledMessage,
} from "store/chat/reducers";
import { timmerRunning } from "store/timmer/reducers";
import { exams } from "store/exams/reducers";
import { standardexams } from "store/standardexams/reducers";
import instructions from "store/instructions/reducers";
import { wheelModal, checkListModal, noiseModal, trafficModal } from "store/wheel/reducers";
import { googleAuthKey } from "store/googleClassRoom/reducers";
import { story, standards , literacy_purpose  } from "store/story/reducers";
import { apexams } from "store/apexams/reducers";
import { howToVideos } from "store/howToVideos/reducers";
import { notifications } from "./notification/reducers";
import { canvasAuthDistrict , canvasAssignmentCategory  } from "store/canvas/reducers";
import { welcomeVideos } from "store/welcomeVideo/reducers";
import { licences } from "store/licences/reducers";
import { vocabulary } from './vocabulary/reducers';
import { translationPractice } from './translationPractice/reducers';
import { ideas , ideaModal  } from "./idea/reducers"
import { playGameModal , oneGameModal , class_game_activity } from "./one_game/reducers"
import { currentGameSession  } from "./game_session/reducers"
import { oneway_teacher_video  } from "./1wayteachervideo/reducers"
import { one_game_video } from "./1GameVideo/reducers"
import {debateModal} from "./OneWayDebate/reducers"
import {oneway_debate} from './debate/reducers'
import { class_user_logs  , messageAlertView } from "./live_logs/reducers";
import { mainbookPageView, ebookGalleryView, sentenceView, answerView, aiAnswerView, storyView, pdfView, activityStandardsView } from "./main_book_popup/reducers"
import { oneWayWidgets } from './widgets/reducers';
import { superLesson } from "./SuperLesson/reducers";
import { favourite_video } from "./FavouriteVideo/reducers";
import { ebook_highlights } from "./ebook_highlighter/reducers";
import { differentiationLesson } from "./DifferentiationLesson/reducers";
import { rubrices } from "./rubric/reducers";
import { audioPlayer } from "./audio/reducers";
import { loaderClassActivityAndQuiz } from "./loadClassActivityAndQuiz/reducer";
import { widgetGroupReducer, widgetStationReducer, widgetWheelReducer } from "./widgetWheel/reducers";
import { non_native_ebook_highlights } from "./ebookNonNativeImageHighLighter/reducers";
import { bingoModal } from "./OneWayBingo/reducers";
import { learningModuleCount, oneway_bingo, teachers_bingo } from "./bingo/reducers";
import {  placement_exam_distict_assignment , placement_exam_list , placement_exam_submission_by_examcode , placement_exam_session , placement_exam_org_config} from "./placement_exam/reducers"
import { book_grammar_content, book_pages_translations, book_vocab_content } from "./page_translations/reducers";
import { vocabulary_cogantes } from "./cogantes/reducers";
import { phrases } from "./Phrases/reducers";
import { chatState } from "./chatOpen/reducer";
import { getAllSlides, openSlideWidget } from "./slides/reducer";
import { one_game_gallery } from "./1GameGallery/reducers";
import { one_game_category } from "./1GameCategory/reducers";
import { worksheetViewReducer } from "./worksheetView/reducer";
import { worksheetReducer, worksheetImageReducer } from "./worksheet/reducers";
import { articleLevels, oneClassStory, oneStoryWithAi } from "./StoryAiCofig/reducers";
import { wordBankReducer } from "./word_bank/reducer";
import { whats_new } from "./whatsNew/reducers"
import { studentGroupReducer } from "./studentGroup/reducers";
import { UI } from "./UI/reducers";
import { sentenceStarter, sentenceStarterPopup } from "./sentenceStarter/reducers";
import { extra_resource_book } from "./extraResource/reducers";
import { image_gallery } from "./image_gallery/reducers";
import { 
  lessonPlansByBook, 
  lessonPlansByBookAndUser
} from "./lesson_plan/reducers";
import { userPermissions, activityPermissions } from "./permissions/reducers";
//  ----------------------------------------------------------------------------
//  Root reducer
//  ----------------------------------------------------------------------------
const appReducer = combineReducers({
    activities,
    ownGraphicOrganizers,
    booksAllList,
    userBooksList,
    activity,
    classes,
    allClasses,
    classActivities,
    classNotes,
    classUsers,
    profile_config,
    profile_picture_picker,
    classQuizzes,
    currentClass,
    currentOrg,
    currentUser,
    districts,
    allSchools,
    interaction,
    interactions,
    notes,
    organizations,
    quiz,
    quizzes,
    schools,
    submissions,
    userClasses,
    users,
    allUser,
    tipsBook,
    userPreference,
    selectedUser,
    feedback,
    feedbackForm,
    logs,
    bookUnitList,
    googleCourseMapByDistrict,
    alertView,
    resources,
    videos,
    orgTeacherData,
    cleverCourses,
    cleverUserInfo,
    tenant,
    bookmarks,
    servertime,
    chatUser,
    socketConnection,
    chatMessages,
    timmerRunning,
    userChatConfig,
    scheduledMessage,
    exams,
    standardexams,
    instructions,
    usersByClass,
    schoologyGradeCategory,
    schoologyAllClassGradeCategory,
    schoologyAssignment,
    wheelModal,
    noiseModal,
    bookOrder,
    googleAuthKey,
    howToVideos,
    canvasAuthDistrict,
    welcomeVideos,
    story,
    standards,
    apexams,
    allUserCount,
    booksActiveInActive,
    licences,
    distTeacher,
    distStudents,
    notifications,
    vocabulary,
    translationPractice,
    canvasAssignmentCategory,
    literacy_purpose,
    ideas,
    ideaModal,
    playGameModal,
    oneGameModal,
    currentGameSession,
    oneway_teacher_video,
    one_game_video,
    distDashboardInfo,
    distExamGraphData,
    distBookUsesData,
    distContentExamData,
    debateModal,
    oneway_debate,
    class_game_activity,
    class_user_logs,
    messageAlertView,
    all_district_teacher,
    mainbookPageView,
    ebookGalleryView,
    checkListModal,
    oneWayWidgets,
    trafficModal,
    sentenceView,
    bookNotes,
    superLesson,
    favourite_video,
    ebook_highlights,
    non_native_ebook_highlights,
    differentiationLesson,
    answerView,
    pdfView,
    activityStandardsView,
    rubrices,
    audioPlayer,
    loaderClassActivityAndQuiz,
    widgetWheelReducer,
    widgetGroupReducer,
    widgetStationReducer,
    aiAnswerView,
    matchMakingView,
    bingoModal,
    oneway_bingo,
    teachers_bingo,
    placement_exam_distict_assignment,
    placement_exam_list , 
    placement_exam_submission_by_examcode , 
    placement_exam_session,
    currentAllTeacherClass,
    placement_exam_org_config,
    book_pages_translations,
    vocabulary_cogantes,
    phrases,
    chatState,
    getAllSlides,
    openSlideWidget,
    one_game_gallery,
    one_game_category,
    oneStoryWithAi,
    oneClassStory,
    storyView,
    book_grammar_content,
    book_vocab_content,
    worksheetViewReducer,
    worksheetReducer,
    worksheetImageReducer,
    articleLevels,
    vocab_permission_for_user,
    class_toggle_permission,
    wordBankReducer,
    whats_new,
    studentGroupReducer,
    UI,
    sentenceStarter,
    sentenceStarterPopup,
    adminHomeInfo,
    extra_resource_book,
    image_gallery,
    userAllowedBooks,
    lessonPlansByBook,
    lessonPlansByBookAndUser,
    class_ai_config_enabled,
    learningModuleCount,
    booksCoverList,
    userPermissions,
    activityPermissions,
    shareList
});

const rootReducer = (state, action) => {
    if (action.type === "USER_LOGOUT") {
        storage.removeItem("persist:root");
        return appReducer(undefined, action);
    }

    return appReducer(state, action);
}
export default rootReducer;
